document.addEventListener("DOMContentLoaded", function () {
  function updateHiddenProperties(event) {
    let input = event.target;
    if (input.type === "radio" && input.checked) {
      let optionName = input.name;
      // Ignore "id" since it's a variant ID, not a product option
      if (optionName.toLowerCase() === "id") return;
      
      // Capitalize first letter to match hidden input format
      let formattedOptionName = optionName.charAt(0).toUpperCase() + optionName.slice(1);
      
      // Get all property inputs and find case-insensitive match instead of exact match
      let allPropertyInputs = document.querySelectorAll('input[name^="properties["]');
      let hiddenInput = null;
      
      for (const propInput of allPropertyInputs) {
        // Extract property name from input name attribute
        const propertyName = propInput.name.replace('properties[', '').replace(']', '');
        // Do case-insensitive comparison
        if (propertyName.toLowerCase() === formattedOptionName.toLowerCase()) {
          hiddenInput = propInput;
          break;
        }
      }
      
      if (!hiddenInput) return;
      hiddenInput.value = input.value;
    }
  }
  
  // Attach event listeners to radio inputs
  document.querySelectorAll("input[type='radio'][name]").forEach(input => {
    input.addEventListener("change", updateHiddenProperties);
  });
  
  // Initialize hidden inputs on page load
  document.querySelectorAll("input[type='radio'][name]:checked").forEach(input => {
    updateHiddenProperties({ target: input });
  });
});